/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { NbAuthJWTToken, NbAuthResult, NbAuthService, NbLoginComponent, NB_AUTH_OPTIONS } from '@nebular/auth';
import { CookieService } from 'ngx-cookie';
import { AuthGuardService } from '../../@core/service/auth-guard.service';
import { UserModel } from '../../@models';

@Component({
  selector: 'ngx-login',
  styleUrls: ['./login-patch.component.scss'],
  templateUrl: './login-patch.component.html',
})
export class NbLoginPatchComponent extends NbLoginComponent {

  showOtpQuery = false;
  oneTimePin = null;
  data: { user: UserModel, otpHash: string[], pin: number, extra: any } = {} as any;

  constructor(protected service: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    protected cd: ChangeDetectorRef,
    protected router: Router,
    protected cookie: CookieService,
    public auth: AuthGuardService) {

    super(service, options, cd, router)

  }

  login(): void {
    this.errors = [];
    this.messages = [];
    this.submitted = true;

    this.data.user = this.user;
    this.data.otpHash = [this.cookie.get('otpHash')];

    this.service.authenticate(this.strategy, this.data).subscribe(async (result: NbAuthResult) => {
      this.submitted = false;

      const err = result.getResponse().error;
      if ( err && err.errors && err.errors.otpHash === 'missing') {
        this.showOtpQuery = true;
        this.errors = ['An email with an one-time PIN has been sent to your mailbox'];
        this.messages = [];
        return;
      } else if ( err && err.errors && err.errors.pin === 'wrong') {
        this.showOtpQuery = true;
        this.errors = ['PIN is not correct, please try again.'];
        this.messages = [];
        return;
      }

      const token = (result.getToken() as NbAuthJWTToken);
      const otpHash = token && token.getPayload() && token.getPayload().otpHash;
      if (otpHash) {
        this.cookie.put('otpHash', otpHash.hash, { expires: otpHash.expires });
      }

      if (result.isSuccess()) {
        this.messages = result.getMessages();
      } else {
        this.errors = result.getErrors();
      }

      await this.auth.loadMe();
      // console.log('login', result, this.auth?.user, this.auth?.user?.erpRoles?.noCrm, this.auth?.user?.erpRoles?.warehousing);
      if (this.auth?.user?.erpRoles?.noCrm && this.auth?.user?.erpRoles?.warehousing) {
        this.router.navigateByUrl('pages/warehousing');
      } else if (this.auth && this.auth.user && this.auth.user.erpRoles.dashboard) {
        this.router.navigateByUrl('pages/dashboard');
      } else {
        this.router.navigateByUrl('pages/news');
      }

      this.cd.detectChanges();
    });
  }
}
